import { FC, SVGAttributes } from 'react';

const CheckLine: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M19.923 8.63034C20.4494 9.00192 20.5749 9.72987 20.2033 10.2563L13.4303 19.8515C12.8656 20.6513 11.6888 20.6786 11.0877 19.9058L7.24597 14.9664C6.85039 14.4578 6.94201 13.7248 7.45062 13.3292C7.95922 12.9336 8.69221 13.0253 9.08779 13.5339L12.2048 17.5414L18.2971 8.91067C18.6687 8.38427 19.3966 8.25877 19.923 8.63034Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6668 14.25C25.6668 20.6934 20.4435 25.9167 14.0002 25.9167C7.55684 25.9167 2.3335 20.6934 2.3335 14.25C2.3335 7.80672 7.55684 2.58337 14.0002 2.58337C20.4435 2.58337 25.6668 7.80672 25.6668 14.25ZM23.9168 14.25C23.9168 19.7269 19.477 24.1667 14.0002 24.1667C8.52334 24.1667 4.0835 19.7269 4.0835 14.25C4.0835 8.77322 8.52334 4.33337 14.0002 4.33337C19.477 4.33337 23.9168 8.77322 23.9168 14.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CheckLine;
